import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TableCustom, Paginator } from "@components";
// import stylesMyCourses from "@pages/InstructorCoursesPage/MyCoursesTab/styles/MyCoursesTab.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getMyPurchasesAction } from "@redux/actions";
import { replaceErrorImage } from "@helpers";
// import { ConfirmModal } from "@components/ConfirmModal/ConfirmModal";

import styles from "./styles/MyPurchasesTab.module.css";

const MyPurchasesTab = () => {
  const dispatch = useDispatch();
  const { myPurchases } = useSelector((state) => state.instructorCourse);

  useEffect(() => {
    dispatch(getMyPurchasesAction());
  }, []);

  const columns = [
    // {
    //   title: "Item No.",
    //   dataIndex: "itemNo",
    // },
    {
      title: "Thumbnail",
      dataIndex: "thumbnailUrl",
      render: (thumbnail) => {
        return (
          <img
            src={thumbnail}
            alt={"thumbnail course"}
            style={{ width: "100px", height: "60px", objectFit: "cover" }}
            onError={replaceErrorImage}
          />
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (title, item) => {
        return (
          <Link to={`/course/${item.id}`} className={styles.link}>
            {title}
          </Link>
        );
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (price) => (
        <p className="text-danger m-0">
          <strong>${price}</strong>
        </p>
      ),
    },
    {
      title: "Instructor",
      dataIndex: "user",
      render: (user) => {
        return (
          <Link
            to={`/instructor-profile-view/${user.id}`}
            className="text-decoration-none"
          >
            {user.fullName}
          </Link>
        );
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (category) => {
        return (
          <Link
            to={`/explore?CategoryId=${category.id}`}
            className="text-decoration-none"
          >
            {category.name}
          </Link>
        );
      },
    },
    // {
    //   title: "Delivery Type",
    //   dataIndex: "id",
    //   render: () => {
    //     return <strong className="text-danger">Download</strong>;
    //   },
    // },

    // {
    //   title: "Actions",
    //   dataIndex: "id",
    //   render: (id) => {
    //     return (
    //       <div>
    //         {/* <i className={clsx("bi bi-download", stylesMyCourses.icon)}></i> */}
    //         <ConfirmModal
    //           onSubmit={() => {
    //             dispatch(deleteCourseAction({ id: id, type: "purchase" }));
    //           }}
    //           title="Delete Course"
    //           submitButton="Delete"
    //           body="Are you sure to delete this course?"
    //         >
    //           <i className={clsx("bi bi-trash ml-2", stylesMyCourses.icon)}></i>
    //         </ConfirmModal>
    //         {/* <i className={clsx("bi bi-printer ml-2", stylesMyCourses.icon)}></i> */}
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <>
      <TableCustom
        columns={columns}
        dataSource={myPurchases.data}
        isLoading={myPurchases.processing}
      />
      <Paginator pagination={myPurchases.pagination} />
    </>
  );
  // return <TableCustom columns={columns} dataSource={myPurchasesData} />;
};

/* required: display name */
MyPurchasesTab.displayName = "MyPurchasesTab";

/* required: props types */
MyPurchasesTab.propTypes = {};

/* required: default props */
MyPurchasesTab.defaultProps = {};

export { MyPurchasesTab };
